
import React from "react";
import Modal from "react-bootstrap/Modal";
import "./view-detail.css";
import Tooltip from "@mui/material/Tooltip";

function Field({ label, value }) {
  return (
    <div className="col-span-1">
      <div className="font-bold mb-1">{label}:</div>
      <input
        type="text"
        className="kr-view-field"
        value={value ?? ""}
        readOnly
        onFocus={(e) => e.target.select()}
      />
    </div>
  );
}

function ShowModal(details) {
  let currentAsset = details.details.asset;
  const d = details?.details?.data;

  return (
    <Modal
      centered
      className="modal fade show"
      {...details}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Detailed Information: {d?.systemId}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="grid grid-cols-3 gap-3 pointer-events-none">
          <Field label="Serial No" value={d?.serialNo} />
          <Field label="Product No" value={d?.productNo} />

          {currentAsset === "Network" || currentAsset === "OtherAsset" ? (
            <Field label="System Model" value={d?.model} />
          ) : (
            <Field
              label="System Model"
              value={d?.modelNo?.length > 0 ? d?.modelNo : "---"}
            />
          )}

          {currentAsset === "Network" ? (
            <>
              <Field label="Os" value={d?.os} />
              <Field label="Ram" value={d?.ram} />
              {/* <Field
                label="Processor"
                value={d?.processor?.length > 0 ? d?.processor : "---"}
              /> */}
              <Field label="Disk" value={d?.diskName} />
              <Field label="Network Port" value={d?.networkPort} />
              <Field label="Location" value={d?.location} />
            </>
          ) : null}

          <div
            className={`col-span-1 ${currentAsset === "Network" || currentAsset === "OtherAsset"
              ? ""
              : "hidden"
              }`}
          >
            <Field label="Asset Type" value={d?.assetType} />
          </div>

          {currentAsset === "CPU" || currentAsset === "Laptop" ? (
            <>
              <Field
                label="Machine Type Model"
                value={d?.macId?.length > 0 ? d?.macId : "---"}
              />

              {currentAsset === "Laptop" && (
                <Field
                  label="Dimension"
                  value={d?.dimension?.length > 0 ? d?.dimension : "---"}
                />
              )}

              <Field label="RAM" value={d?.ram} />
              <Field
                label="Processor"
                value={`${d?.brandName || ""} ${d?.brandTypeName || ""} ${d?.generationName || ""}`}
              />
              <Field label="Generation" value={d?.generation} />
              <Field label="OS Type" value={d?.windowsOS} />
              <Field label="Storage Type" value={d?.storageType} />
              <Field label="Storage Size" value={d?.storageSize} />
              <Field label="Monitor" value={d?.isMonitor ? "Yes" : "No"} />
              <Field label="Keyboard" value={d?.isKeyborad ? "Yes" : "No"} />
              <Field label="Mouse" value={d?.isMouse ? "Yes" : "No"} />
              <Field label="Headset" value={d?.isHeadSet ? "Yes" : "No"} />
              <Field
                label="AV Installed"
                value={d?.isAVInstalled ? "Yes" : "No"}
              />
              <Field
                label="IP Adress"
                value={d?.ipAddress?.length > 0 ? d?.ipAddress : "---"}
              />
            </>
          ) : null}

          <div
            className={`col-span-1 ${currentAsset === "Network" || currentAsset === "OtherAsset"
              ? "hidden"
              : ""
              }`}
          >
            <Field label="Brand" value={d?.brand} />
          </div>

          <div
            className={`col-span-1 ${currentAsset === "Monitor" ? "" : "hidden"}`}
          >
            <Field label="Screen Size" value={d?.screensize} />
          </div>

          <Field label="Created By" value={d?.createdBy} />

          <Field
            label="Purchase Date"
            value={
              d?.purchaseDate === null || d?.purchaseDate === undefined
                ? "---"
                : d?.purchaseDate?.split("T")[0]
            }
          />

          <Field
            label="Warranty Till"
            value={
              d?.warrantyTill === null || d?.warrantyTill === undefined
                ? "---"
                : d?.warrantyTill?.split("T")[0]
            }
          />

          <Field label="Created On" value={d?.createdOn?.split("T")[0]} />

          {/* <div
            className={`col-span-1 ${currentAsset === "OtherAsset" ? "" : "hidden"}`}
          >
            <Field
              label="Imei"
              value={
                d?.imei?.length === 0 || d?.imei === null ? "---" : d?.imei
              }
            />
          </div> */}

          <div
            className={`col-span-1 ${currentAsset === "OtherAsset" ? "" : "hidden"}`}
          >
            <Field
              label="Wired Type"
              value={
                d?.wiredStatus?.length === 0 || d?.wiredStatus === null
                  ? "---"
                  : d?.wiredStatus
              }
            />
          </div>

          <div
            className={`col-span-1 ${currentAsset === "Network" || currentAsset === "OtherAsset"
              ? "hidden"
              : ""
              }`}
          >
            <Field label="No.of Months" value={d?.noOfMonthsOld} />
          </div>

          {currentAsset === "Desktop" || currentAsset === "CPU" ? (
            <>
              <Field label="Licensed" value={d?.isLicensed ? "Yes" : "No"} />
              <Field
                label="License no"
                value={
                  d?.windowsLicense?.length > 0 ? d?.windowsLicense : "---"
                }
              />
            </>
          ) : null}

          <Field label="Assigned" value={d?.isAssigned ? "Yes" : "No"} />
          {currentAsset !== "Network" && (
            <>
              <Field
                label="Assigned To"
                value={d?.assignedTo?.length > 0 ? d?.assignedTo : "---"}
              />

              <Field
                label="Assigned To Prev"
                value={
                  d?.assignedToPrevious?.length > 0
                    ? d?.assignedToPrevious
                    : "---"
                }
              />
            </>
          )}

          <Field label="State" value={d?.isActive ? "Active" : "In Active"} />

          <div className="col-span-1">
            <div className="font-bold mb-1">Remarks:</div>
            <textarea
              className="kr-view-field"
              value={d?.remarks?.length > 0 ? d?.remarks : "---"}
              readOnly
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

function ViewDetail(data) {
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <Tooltip title="View Detail" placement="top" arrow>
        <div
          className="kr-tbl-view cursor-pointer action-item"
          onClick={() => setModalShow(true)}
        >
          <span className="svg-icon">
            <svg x="0px" y="0px" viewBox="0 0 700 700">
              <g>
                <path
                  d="M671,321.2C635.5,277,507.5,131.6,350,131.6S64.6,277,29.1,321.2c-10,12.7-10,30.8,0,43.5C64.6,409.6,192.6,555,350,555
                                       S635.5,409.6,671,365.4C680.3,352.7,680.3,333.9,671,321.2L671,321.2z M350,482.7c-77,0-139.4-63-139.4-139.4S273,204,350,204
                                       s139.4,63,139.4,139.4C489.4,420.4,427.1,482.7,350,482.7z"
                ></path>
              </g>
            </svg>
          </span>
        </div>
      </Tooltip>

      <ShowModal
        details={data}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default ViewDetail;